export enum TemplateCategory {
  STANDARD = 'Standard Templates',
  SYSTEM = 'System Templates',
  AUTOMATION = 'Automation Templates',
}
